import React, { FC } from "react";
import { DictType, Project } from "@pma/types";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@components/common/card";
import { Separator } from "@components/common/separator";
import { LocateFixed } from "lucide-react";
import useTranslator from "@hooks/use-translator";

interface PopupContentProps {
  project: Project;
}
const PopupContent: FC<PopupContentProps> = ({ project }) => {
  const { translate } = useTranslator();
  const addressPoint = project?.address_point as DictType;
  return (
    <Card className="bg-white border-none shadow-none w-[220px] p-0">
      <CardHeader className="p-0 capitalize">
        <CardTitle className="text-sm flex gap-2 items-center">
          <strong>{translate("Project address")}</strong>{" "}
          <LocateFixed size={14} />
        </CardTitle>{" "}
        <CardDescription>
          <span className="">{project?.address_text}</span>
        </CardDescription>
      </CardHeader>
      <Separator className="my-2" />
      <div className="flex flex-col">
        <div className="flex gap-3">
          <div className="">
            <span className="flex flex-col gap-[1px]">
              {addressPoint?.data?.lng}
            </span>
            <small className="text-muted-foreground">
              {translate("Longitude")}
            </small>
          </div>
          <div className="flex flex-col gap-[1px]">
            <span>{addressPoint?.data?.lat}</span>
            <small className="text-muted-foreground">
              {translate("Latitude")}
            </small>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default PopupContent;
